<template>
  <div class="container">
    <home-title
      title="秒学设计"
      link2="note"
      :icon="require('@/assets/images/home/home_title/icon12.svg')"
      :newWindow="true"
    ></home-title>

    <div class="note_box">
      <div
        class="note_item"
        v-for="e in noteData"
        :key="e.id"
        @click="goNote(e.id)"
      >
        <div class="note_img">
          <img
            :src="$prefixSrc(e.type == 1 ? e.cover : e.path[0].url)"
            alt=""
            class="ta3"
          />
          <div class="note_num ta3">
            <i class="iconfont icon-a-zu823"></i>
            <span>{{ e.view }}</span>
          </div>
        </div>
        <div class="note_title toh2">
          {{ e.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeTitle from "./components/homeTitle";

export default {
  name: "studyDesign",
  components: { homeTitle },
  props: {
    noteData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goNote(id) {
      this.$router.push(`/note/${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.note_box {
  display: flex;
  align-items: center;
  gap: 20px;
  .note_item {
    width: 260px;
    cursor: pointer;
    position: relative;
    .note_img {
      width: 100%;
      height: 340px;
      border-radius: 15px;
      overflow: hidden;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &::before {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: transparent;
        transition: all 0.3s;
        z-index: 1;
      }
      .note_num {
        opacity: 0;
        position: absolute;
        top: 5px;
        left: 5px;
        padding: 4px 10px;
        display: flex;
        align-items: center;
        gap: 3px;
        font-size: 14px;
        color: #fff;
        background: rgba(0, 0, 0, 0.55);
        border-radius: 37px;
        z-index: 2;
        i {
          font-size: 16px;
        }
      }
    }
    &:hover {
      .note_img {
        &::before {
          background: rgba(0, 0, 0, 0.3);
        }
        .note_num {
          opacity: 1;
        }
      }
    }

    .note_title {
      height: 42px;
      margin: 10px;
      font-size: 16px;
      color: #333;
    }
  }
}
@media screen and (max-width: 1500px) and (min-width: 270px) {
  .note_box {
    gap: 16px;
    .note_item {
      width: 207px;
      .note_img {
        height: 270px;
        border-radius: 10px;
      }
      .note_title {
        margin: 6px;
        font-size: 13px;
      }
    }
  }
}
</style>
